import httpApi from '../../../hooks/api/httpApi';

const createService = async (ecomId: number) => {
    const res = await httpApi.post<{ success: boolean }>(`/api/ecom/${ecomId}/carrier-service/create`);
    return res.getData();
};

const deleteService = async (ecomId: number) => {
    const res = await httpApi.post<{ success: boolean }>(`/api/ecom/${ecomId}/carrier-service/delete`);
    return res.getData();
};

export default {
    createService,
    deleteService,
};
